import {useDispatch, useSelector} from 'react-redux'
import {Fragment, useEffect, useState} from 'react'
import {useHistory, useParams, useLocation} from 'react-router-dom'
import {RootState} from '../../../../setup'
import {QueryData} from '../../../reusable-components/tables/DynamicTableTypes'
import {deleteNursesNotes, getNursesNotes} from './store/action'
import {toast} from 'react-toastify'
import TableTitle from '../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../reusable-components/tables/TableSearchBar'
import {hasPermission} from '../../../../_helper/hasPermission'
import {permissions} from '../../../../_constants/permissions'
import DynamicTable from '../../../reusable-components/tables/DynamicTable'
import AddButton from '../../../reusable-components/Buttons/AddButton'
import TableButton from '../../../reusable-components/tables/TableButton'
import {
  RECORDS_COLUMNS_DATA_MAPPING,
  RECORDS_LISTING_COLUMNS,
  RECORDS_SORTING_COLUMNS,
} from './GENERAL_TABLE_CONSTANTS'
import axios from 'axios'
import dayjs from 'dayjs'
import IsFormCompletedModal, { validateFormCompletion } from './isFormCompleted'
const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

export const ListNotes = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [fullData, setFullData] = useState<any[]>([])
  const [deletedID, setDeletedID] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [loadingStates, setLoadingStates] = useState({})
  const [isFetchingData, setIsFetchingData] = useState(true)
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const timeZone = useSelector(selectTimeZone)
  const userPermissions = auth.user.roleId
  const history = useHistory()
  const params: {id: string} = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const noteType = queryParams.get('noteType')
  const nursesAssessmentId = queryParams.get('nursesAssessmentId')
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const [hasExpiredDocuments, setHasExpiredDocuments] = useState(false)
  const [logoUrl, setLogoUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const companyLogo = auth?.user?.companyLogo;
  const isDocumentExpired = auth?.user?.isDocumentExpired;
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [pendingDownloadRow, setPendingDownloadRow] = useState(null)
  const [isPDFDownloaded, setIsPDFDownloaded] = useState(false);
  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      try {
        const response = await axios.get(`/nursesNotes/getByClient/${params.id}?noteType=${noteType}`, {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
          },
        })
        const {data, currentPage, totalCounts} = response?.data
        setFullData(data)
        const mappedData = data.map((item) => {
          const adjustedStartDate = new Date(item.startDate)
          adjustedStartDate.setDate(adjustedStartDate.getDate())
          const adjustedEndDate = new Date(item.endDate)
          adjustedEndDate.setDate(adjustedEndDate.getDate())
          const formattedStartDate = `${(adjustedStartDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${adjustedStartDate
            .getDate()
            .toString()
            .padStart(2, '0')}-${adjustedStartDate.getFullYear().toString().slice(-2)}`
          const formattedEndDate = `${(adjustedEndDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${adjustedEndDate
            .getDate()
            .toString()
            .padStart(2, '0')}-${adjustedEndDate.getFullYear().toString().slice(-2)}`
          const dateRange = `${formattedStartDate} to ${formattedEndDate}`
          return {
            _id: item._id,
            dateRange,
            noteType: item.noteType,
            visitType: item.visitType,
            clientName: item.clientFullName || 'N/A',
            date: item.date,
            isPdfGenerated: item.isPdfGenerated,
            pdfS3Key: item.pdfS3Key,
            clientFullName: item.clientFullName,
          }
        })
        setFilteredData(mappedData)
        setHasExpiredDocuments(isDocumentExpired || false)
        setQueryData((prevState) => {
          return {
            ...prevState,
            currentPage,
            totalCounts,
          }
        })
      } catch (err) {
        console.error('Error fetching data:', err)
      } finally {
        setIsFetchingData(false)
      }
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    deletedID,
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
    isPDFDownloaded
  ])
   const fetchPresignedUrl = async (key: string, objective: string) => {
      try {
        if (key?.startsWith("http")) {
          console.log("Already a URL, skipping presigned URL fetch.");
          if(objective === 'companyLogo'){
            setLogoUrl(key); 
          }
          return;
        }
    
        const response = await axios.get(`/batchfile/fetch-file-url`, {
          params: { fileKey: key },
        });
    
        if (response.status === 200) {
          if(objective === 'companyLogo'){
            setLogoUrl(response.data.presignedUrl);
          } else if(objective === 'pdf'){
            return response.data.presignedUrl;
          }
        }
      } catch (error) {
        console.error("Error fetching company logo URL:", error);
        setErrorMessage("Failed to fetch company logo.");
      }
    };
    
    useEffect(() => {
      if (companyLogo) {
        fetchPresignedUrl(companyLogo, 'companyLogo');
      }
    }, [companyLogo]);
  const DeleteNote = async (row: {_id: string}) => {
    try {
      const response: any = await dispatch(deleteNursesNotes(row._id))
      if (response.payload?.success) {
        toast.success('Deleted')
        setDeletedID(row._id)
        setQueryData((prevState) => ({
          ...prevState,
          searchTerm: '',
          pageNumber: 1,
        }))
      } else {
        toast.error('Error')
      }
    } catch (error) {
      console.error('Error deleting note:', error)
      toast.error('Error', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    }
  }
  const setLoading = (id, action, isLoading) => {
    setLoadingStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [action]: isLoading,
      },
    }))
  }
  const onDownload = async (row) => {
    const filteredRowData = fullData?.find((item) => item._id === row._id)
    if (!filteredRowData) {
      console.error('No data found for this row')
      return
    }
    
    const validationResult = validateFormCompletion(filteredRowData, 'nursesNotes')
    if (!validationResult.isValid) {
      setPendingDownloadRow(filteredRowData)
      setShowWarningModal(true)
      return
    }
    await performDownload(row)
  }

  const performDownload = async (row) => {
    try {
      setLoading(row._id, 'download', true)
      if(row?.isPdfGenerated){
        setIsPDFDownloaded(row?._id)
        const presignedUrl = await fetchPresignedUrl(row?.pdfS3Key, 'pdf')
        
        // Use the presigned URL directly for download
        const link = document.createElement('a')
        link.href = presignedUrl
        link.setAttribute('download', `${row?.noteType}_Nurses_Note_for_${row?.clientFullName}.pdf`);
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        setLoading(row._id, 'download', false)
        return
      }   
      let finalCompanyLogoUrl = '';
      if (companyLogo?.startsWith('http')) {
        finalCompanyLogoUrl = companyLogo;
      } else {
        finalCompanyLogoUrl = logoUrl;
      }
      const filteredRowData = fullData?.find((item) => item._id === row._id)
      if (!filteredRowData) {
        console.error('No data found for this row')
        setLoading(row._id, 'download', false)
        return
      }
    const formattedNextAppt = filteredRowData?.assessment?.nextAppt
      ? dayjs.utc(filteredRowData?.assessment?.nextAppt).tz(timeZone, true).format('MM-DD-YYYY')
      : null;

    const formattedStartDate = filteredRowData?.startDate
      ? dayjs.utc(filteredRowData.startDate).tz(timeZone, true).format('MM-DD-YYYY')
      : 'No details provided';

    const formattedEndDate = filteredRowData?.endDate
      ? dayjs.utc(filteredRowData.endDate).tz(timeZone, true).format('MM-DD-YYYY')
      : 'No details provided';

      const formData = {
        ...filteredRowData,
        clientId : filteredRowData.clientId,
        createdAt: filteredRowData?.createdAt,
        userId: auth.user._id,
        // painAssessment:  filteredRowData?.painAssessment,
        companyLogoUrl: finalCompanyLogoUrl,
        painAssessment: Array.isArray(filteredRowData?.painAssessment)
          ? filteredRowData.painAssessment.map((item) => ({
              location: item?.location || 'No details provided',
              duration: item?.duration || 'No details provided',
              score: item?.score || 'No details provided',
              description: item?.description || 'No details provided',
              noteType: item?.noteType || 'No details provided',
            }))
          : [],
        activity: Array.isArray(filteredRowData?.activity)
          ? filteredRowData.activity.map((item) => ({
              details: item?.details || 'No details provided',
            }))
          : [],
        poc: Array.isArray(filteredRowData?.poc)
          ? filteredRowData.poc.map((item) => ({
              pocDesc: item?.pocDesc || 'No details provided',
            }))
          : [],
        vitalSigns: {
          bp: filteredRowData?.vitalSigns?.bp,
          pulse: filteredRowData?.vitalSigns?.pulse,
          rr: filteredRowData?.vitalSigns?.rr,
          temp: filteredRowData?.vitalSigns?.temp,
          pain: filteredRowData?.vitalSigns?.pain,
          o2sat: filteredRowData?.vitalSigns?.o2sat,
        },
        assessment: {
          neuro: filteredRowData?.assessment?.neuro,
          skin: filteredRowData?.assessment?.skin,
          heent: filteredRowData?.assessment?.heent,
          respiratory: filteredRowData?.assessment?.respiratory,
          cardiac: filteredRowData?.assessment?.cardiac,
          gi: {
            lastBm: filteredRowData?.assessment?.gi?.lastBm,
            weight: {
              value: filteredRowData?.assessment?.gi?.weight?.value,
              type: filteredRowData?.assessment?.gi?.weight?.type,
            },
          },
          gu: filteredRowData?.assessment?.gu,
          patientConcerns: filteredRowData?.assessment?.patientConcerns,
          notes: filteredRowData?.assessment?.notes,
          dme: filteredRowData?.assessment?.dme,
          medRec: filteredRowData?.assessment?.medRec,
          nextAppt: formattedNextAppt,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          createdAt: filteredRowData?.createdAt,
        },
      }
      const response = await axios.post('/nursesNotes/generateNursesNotesPDF', formData, {
        responseType: 'blob',
      })
      const blob = new Blob([response.data], {type: 'application/pdf'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filteredRowData.noteType}_Nurses_Note_for_${filteredRowData.clientFullName}.pdf`);
      document.body.appendChild(link)
      link.click()
      setIsPDFDownloaded(row?._id)
      setLoading(row._id, 'download', false)
    } catch (err) {
      console.error('Error while downloading note', err)
      setLoading(row._id, 'download', false)
    }
  }

  const handleWarningModalClose = () => {
    setShowWarningModal(false)
    setPendingDownloadRow(null)
  }
  const onUpdate = ({_id}: {_id: string}) => {
    history.push({
      pathname: `/notes/nurses-notes/entry/edit/${_id}`,
      state: { entries: filteredData },
    })
  }
  
  const onClickAddButton = () => {
    history.push({
      pathname: `/notes/nurses-notes/entry/new`,
      state: { entries: filteredData, clientId: params.id, noteType: noteType, nursesAssessmentId: nursesAssessmentId },
    })
  }
  
  const onView = (row: any) => {
    history.push(`/notes/nurses-notes/entry/${row['_id']}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        <div>
          <TableTitle title='Nurses Notes' />
          {hasExpiredDocuments && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            Your Documents have been expired. Please update them.
          </div>
        )}
          <TableWrapper
            searchField={
              <TableSearchBar
                label='Search'
                variant='outlined'
                size='small'
                value={searchTerm}
                setQueryData={setQueryData}
                setSearchTerm={setSearchTerm}
                margin='normal'
                inputAdornmentPosition='start'
              />
            }
            tableButtons={
              <>
                {(hasPermission(userPermissions, permissions.notes_nurses_note_entry_create) && !hasExpiredDocuments) && (
                  <TableButton
                    variant={'contained'}
                    color={'primary'}
                    title='Create New Entry'
                    onClick={onClickAddButton}
                  />
                )}
              </>
            }
            dynamicTable={
              <DynamicTable
                htmlColumns={[]}
                columns={RECORDS_LISTING_COLUMNS}
                data={filteredData}
                canDownload={(hasPermission(userPermissions, permissions.notes_nurses_note_entry_download) && !hasExpiredDocuments)}
                canUpdate={(hasPermission(userPermissions, permissions.notes_nurses_note_entry_update) && !hasExpiredDocuments)}
                canDelete={(hasPermission(userPermissions, permissions.notes_nurses_note_entry_delete) && !hasExpiredDocuments)}
                columnDataMapping={RECORDS_COLUMNS_DATA_MAPPING}
                sortingColumns={RECORDS_SORTING_COLUMNS}
                clickableRow={false}
                onUpdate={onUpdate}
                onDelete={DeleteNote}
                onDownload={onDownload}
                loadingStates={loadingStates}
                tableLoader={isFetchingData}
                title='Are you sure you want to delete the note'
                setQueryData={setQueryData}
                queryData={queryData}
              />
            }
          />
        </div>
      </div>
      <IsFormCompletedModal
        open={showWarningModal}
        onClose={handleWarningModalClose}
        title="Nurses Notes Form Incomplete"
        description="The Nurses Notes form is not fully completed. To download the PDF, please ensure all the fields are filled:"
        formData={pendingDownloadRow}
        formType="nursesNotes"
        closeButtonText="Close"
      />
    </div>
  )
}
